import { render, staticRenderFns } from "./ClaimsRevisionList.vue?vue&type=template&id=f3445b6a&"
import script from "./ClaimsRevisionList.vue?vue&type=script&lang=js&"
export * from "./ClaimsRevisionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports